const { publicPath } = process.env.CONFIG
const projectUrl = window.location.origin + publicPath
import { showXiaoNeng,showKFService } from "./util";
class Goto {
  install = (vue) => {
    vue.mixin({
      created: function () {
        let that = this
        this.replace = function(url){
          that.next(url,true)
        }
        this.goto = function(url){
          that.next(url,false)
        }
        this.next = function (url,isReplace) {
          if (!url) return
          if (url === 'meiqia') {
            // showMeiQia()
            showXiaoNeng()
          }
          else if (url.indexOf('xiaoneng') == 0){
            showXiaoNeng(url.split(':')[1])
          }
          else if(url === 'KF_SERVICE'){
              showKFService()
          }
          else if(url.indexOf('tel:') == 0){
              window.location.href = url
          }else if (url.indexOf('http://') !== 0 && url.indexOf("https://") !== 0) {
            if(isReplace){
              that.$router.replace(url)
            }else{
              that.$router.push(url)
            }
          }
          else if (url.indexOf(projectUrl) === 0) {
            const path = url.substring(projectUrl.length, url.length)
            if(isReplace){
              that.$router.replace(path)
            }else{
              that.$router.push(path)
            }
          } else {
            window.location.href = url
          }
        }
      }
    })
  }
}

export const goto = new Goto()